import styled from 'styled-components'

export const Dados = styled.div`
  margin-top: 25px;
`

export const ContainerLink = styled.div`
  margin-bottom: 28px;
`
